<template>
  <div id="terms-page" class="body-landing">
    <AnimatedAiBackground />
    <section class="legal-content">
      <div class="container">
        <div class="document-container">
          <router-link class="legal-back-link" :to="{ name: 'landing' }">
            <i class="fas fa-arrow-left" aria-hidden="true"></i>
            Volver al inicio
          </router-link>
          <div class="document-header">
            <router-link class="redirect" to="/">
              <img
                src="/landing/logo-sofia-web.png"
                alt="Sofia"
                class="logo-con"
                style="width: 300px"
              />
            </router-link>
            <h1>Términos y Condiciones</h1>
            <p>
              Al acceder y utilizar el servicio de Agente Sofia, usted acepta
              estar sujeto a estos Términos y Condiciones.
            </p>
          </div>

          <div class="document-content">
            <h2>Uso del Servicio</h2>
            <p>
              Al utilizar nuestro servicio, usted acepta cumplir con estos
              términos y todas las leyes y regulaciones aplicables. Usted es
              responsable de mantener la confidencialidad de su cuenta y
              contraseña y de restringir el acceso a su computadora.
            </p>

            <h3>1. Introducción</h3>
            <p>
              Bienvenido a Smart Sales Agent. Estos términos y condiciones rigen
              el uso de nuestra plataforma y servicios, incluyendo la
              integración con WhatsApp Business API. Al acceder y utilizar
              nuestra plataforma, aceptas estar sujeto a estos términos y
              condiciones, así como a las políticas oficiales de Meta para
              WhatsApp Business. Si no estás de acuerdo con alguna parte de
              estos términos, no podrás acceder a nuestros servicios.
            </p>

            <h3>2. Definiciones</h3>
            <ul>
              <li>
                <strong>Plataforma:</strong> Se refiere al sitio web,
                aplicaciones y servicios de Smart Sales Agent, incluyendo la
                integración con WhatsApp Business API.
              </li>
              <li>
                <strong>Usuario:</strong> Cualquier persona o entidad que acceda
                o utilice la plataforma, incluyendo los usuarios finales de
                WhatsApp.
              </li>
              <li>
                <strong>Servicios:</strong> Todas las funcionalidades,
                herramientas y características disponibles en la plataforma,
                incluyendo la comunicación a través de WhatsApp Business API.
              </li>
              <li>
                <strong>Contenido:</strong> Cualquier información, datos, texto,
                software, música, sonido, fotografías, gráficos, video, mensajes
                u otros materiales transmitidos a través de la plataforma o
                WhatsApp.
              </li>
              <li>
                <strong>Cuenta:</strong> El registro único de un usuario en la
                plataforma, incluyendo la configuración de WhatsApp Business
                API.
              </li>
              <li>
                <strong>WhatsApp Business API:</strong> La interfaz de
                programación de aplicaciones oficial de Meta para la integración
                con WhatsApp Business.
              </li>
            </ul>

            <h3>3. Registro y Cuentas</h3>
            <h4>3.1 Requisitos de Registro</h4>
            <ul>
              <li>
                Debes ser mayor de 18 años o tener la capacidad legal para
                celebrar contratos.
              </li>
              <li>Proporcionar información veraz, precisa y completa.</li>
              <li>Mantener y actualizar la información de tu cuenta.</li>
              <li>No compartir tus credenciales de acceso con terceros.</li>
            </ul>
            <h4>3.2 Responsabilidades de la Cuenta</h4>
            <ul>
              <li>Mantener la confidencialidad de tus credenciales.</li>
              <li>Notificar inmediatamente cualquier uso no autorizado.</li>
              <li>Ser responsable de todas las actividades bajo tu cuenta.</li>
              <li>Cumplir con todas las leyes y regulaciones aplicables.</li>
            </ul>
            <h4>3.3 Suspensión y Terminación</h4>
            <ul>
              <li>
                Nos reservamos el derecho de suspender o terminar cuentas que
                violen estos términos.
              </li>
              <li>
                Podemos suspender temporalmente el acceso por mantenimiento o
                actualizaciones.
              </li>
              <li>
                Los usuarios pueden solicitar la cancelación de su cuenta en
                cualquier momento.
              </li>
              <li>
                La terminación no afecta las obligaciones pendientes o los
                derechos adquiridos.
              </li>
            </ul>

            <h3>4. Servicios y Funcionalidades</h3>
            <h4>4.1 Chatbot y Automatización</h4>
            <ul>
              <li>
                Integración con WhatsApp Business API siguiendo las políticas
                oficiales de Meta.
              </li>
              <li>
                Automatización de respuestas dentro de las 24 horas permitidas
                por WhatsApp.
              </li>
              <li>Uso de plantillas de mensajes pre-aprobadas por WhatsApp.</li>
              <li>
                Respeto a los límites de mensajes y frecuencia establecidos por
                WhatsApp.
              </li>
              <li>
                Procesamiento de lenguaje natural dentro de las directrices de
                Meta.
              </li>
            </ul>
            <h4>4.2 Gestión de Productos y Servicios</h4>
            <ul>
              <li>
                Catálogo digital de productos y servicios aprobado por WhatsApp.
              </li>
              <li>Gestión de inventario y disponibilidad en tiempo real.</li>
              <li>
                Procesamiento de pedidos a través de mensajes de WhatsApp.
              </li>
              <li>
                Generación de reportes y análisis dentro de los límites de
                privacidad.
              </li>
            </ul>
            <h4>4.3 Características Adicionales</h4>
            <ul>
              <li>Panel de control personalizado.</li>
              <li>Herramientas de análisis y métricas.</li>
              <li>Integración con sistemas de pago.</li>
              <li>Funciones de marketing y promoción.</li>
            </ul>

            <h3>5. Uso Aceptable</h3>
            <h4>5.1 Conducta Prohibida</h4>
            <ul>
              <li>Uso ilegal o fraudulento de la plataforma y WhatsApp.</li>
              <li>
                Violación de derechos de propiedad intelectual de Meta y
                terceros.
              </li>
              <li>
                Distribución de malware o contenido dañino a través de WhatsApp.
              </li>
              <li>Spam o comunicación no solicitada en WhatsApp.</li>
              <li>Intento de acceso no autorizado a sistemas de Meta.</li>
              <li>Enviar mensajes masivos no solicitados.</li>
              <li>Compartir contenido inapropiado o prohibido por WhatsApp.</li>
              <li>Suplantar la identidad de Meta o WhatsApp.</li>
            </ul>
            <h4>5.2 Contenido del Usuario</h4>
            <ul>
              <li>Debe cumplir con las políticas de contenido de WhatsApp.</li>
              <li>No debe contener contenido prohibido por Meta.</li>
              <li>Debe ser preciso y no engañoso.</li>
              <li>
                No debe contener material ofensivo, discriminatorio o ilegal.
              </li>
              <li>
                Debe respetar los derechos de autor y propiedad intelectual.
              </li>
              <li>
                No debe incluir contenido que promueva actividades ilegales.
              </li>
            </ul>
            <h4>5.3 Límites de Uso</h4>
            <ul>
              <li>
                Respetar los límites de mensajes establecidos por WhatsApp.
              </li>
              <li>Cumplir con las políticas de uso justo de WhatsApp.</li>
              <li>Respetar los horarios de envío permitidos.</li>
              <li>
                Mantener la frecuencia de mensajes dentro de los límites
                permitidos.
              </li>
              <li>No sobrecargar los sistemas de WhatsApp.</li>
            </ul>

            <h3>6. Propiedad Intelectual</h3>
            <h4>6.1 Derechos de la Plataforma</h4>
            <ul>
              <li>
                Smart Sales Agent retiene todos los derechos sobre la
                plataforma.
              </li>
              <li>El software y el diseño son propiedad exclusiva.</li>
              <li>Las marcas y logos están protegidos.</li>
              <li>
                El contenido generado por la plataforma es propiedad de Smart
                Sales Agent.
              </li>
            </ul>
            <h4>6.2 Licencia de Uso</h4>
            <ul>
              <li>
                Se otorga una licencia limitada, no exclusiva y revocable.
              </li>
              <li>El uso está restringido a los propósitos autorizados.</li>
              <li>No se permite la modificación o ingeniería inversa.</li>
              <li>La licencia termina al finalizar el uso del servicio.</li>
            </ul>
            <h4>6.3 Contenido del Usuario</h4>
            <ul>
              <li>Los usuarios conservan sus derechos sobre su contenido.</li>
              <li>
                Se otorga una licencia para usar el contenido en la plataforma.
              </li>
              <li>
                La licencia incluye derechos de reproducción y distribución.
              </li>
              <li>La licencia es necesaria para proporcionar los servicios.</li>
            </ul>

            <h3>7. Pagos y Facturación</h3>
            <h4>7.1 Tarifas y Precios</h4>
            <ul>
              <li>Los precios se muestran en la moneda especificada.</li>
              <li>Las tarifas pueden cambiar con notificación previa.</li>
              <li>Los impuestos aplicables se añadirán al precio final.</li>
              <li>Los descuentos y promociones tienen términos específicos.</li>
            </ul>
            <h4>7.2 Proceso de Pago</h4>
            <ul>
              <li>Aceptamos los métodos de pago especificados.</li>
              <li>Los pagos se procesan de forma segura.</li>
              <li>Las facturas se generan automáticamente.</li>
              <li>Los reembolsos siguen nuestra política establecida.</li>
            </ul>
            <h4>7.3 Suscripciones</h4>
            <ul>
              <li>Las suscripciones se renuevan automáticamente.</li>
              <li>Se puede cancelar con notificación previa.</li>
              <li>No hay reembolsos por cancelaciones anticipadas.</li>
              <li>Los cambios de plan pueden tener restricciones.</li>
            </ul>

            <h3>8. Limitación de Responsabilidad</h3>
            <h4>8.1 Exclusión de Garantías</h4>
            <ul>
              <li>Los servicios se proporcionan "tal cual".</li>
              <li>No garantizamos disponibilidad ininterrumpida.</li>
              <li>No garantizamos resultados específicos.</li>
              <li>Las garantías implícitas están excluidas.</li>
            </ul>
            <h4>8.2 Limitación de Daños</h4>
            <ul>
              <li>No somos responsables por daños indirectos.</li>
              <li>La responsabilidad está limitada al monto pagado.</li>
              <li>No cubrimos pérdida de datos o beneficios.</li>
              <li>Las limitaciones aplican según la ley.</li>
            </ul>
            <h4>8.3 Indemnización</h4>
            <ul>
              <li>Los usuarios indemnizan por violaciones de términos.</li>
              <li>Cubrimos gastos legales razonables.</li>
              <li>La indemnización incluye reclamos de terceros.</li>
              <li>Se aplica a todas las violaciones de estos términos.</li>
            </ul>

            <h3>9. Modificaciones</h3>
            <p>
              Nos reservamos el derecho de modificar estos términos en cualquier
              momento. Los cambios significativos serán notificados a través de:
            </p>
            <ul>
              <li>Notificación por correo electrónico.</li>
              <li>Aviso en la plataforma.</li>
              <li>Actualización de la fecha de modificación.</li>
              <li>Resumen de cambios realizados.</li>
            </ul>

            <h3>10. Ley Aplicable</h3>
            <p>
              Estos términos se rigen por las leyes de Venezuela. Cualquier
              disputa estará sujeta a la jurisdicción exclusiva de los
              tribunales de Venezuela.
            </p>

            <h3>11. Contacto</h3>
            <p>Para cualquier consulta sobre estos términos, contáctanos en:</p>
            <ul>
              <li>Correo electrónico: contacto@agentesofia.com</li>
              <li>Teléfono: +58 414-5038466</li>
              <li>Dirección: [Dirección física de la empresa]</li>
              <li>Horario de atención: Lunes a Viernes, 9:00 AM - 5:00 PM</li>
            </ul>

            <h3>12. Versión y Fecha de Última Actualización</h3>
            <p>
              Estos términos y condiciones fueron actualizados por última vez el
              [Fecha]. Versión 1.0
            </p>

            <h3>13. Políticas de WhatsApp</h3>
            <p>
              Al utilizar nuestros servicios con WhatsApp Business API, aceptas
              cumplir con las siguientes políticas:
            </p>
            <ul>
              <li>
                Cumplimiento estricto de las políticas oficiales de WhatsApp
                Business API.
              </li>
              <li>
                Respeto a los límites de mensajes y frecuencia establecidos por
                Meta.
              </li>
              <li>
                Uso exclusivo de plantillas de mensajes pre-aprobadas por
                WhatsApp.
              </li>
              <li>
                Manejo responsable y seguro de los datos de los usuarios según
                las políticas de Meta.
              </li>
              <li>
                Cumplimiento de las políticas de privacidad y protección de
                datos de Meta.
              </li>
              <li>
                Respeto a las restricciones de contenido y uso de WhatsApp.
              </li>
              <li>
                Notificación inmediata de cualquier violación de las políticas
                de WhatsApp.
              </li>
              <li>Mantenimiento de la seguridad de las credenciales de API.</li>
              <li>
                Cumplimiento de las regulaciones de protección de datos
                aplicables.
              </li>
              <li>Respeto a los derechos de propiedad intelectual de Meta.</li>
            </ul>

            <h4>13.1 Restricciones de Mensajes</h4>
            <ul>
              <li>
                Los mensajes deben enviarse dentro de las 24 horas posteriores
                al último mensaje del usuario.
              </li>
              <li>
                Después de 24 horas, solo se pueden enviar mensajes de plantilla
                pre-aprobados.
              </li>
              <li>
                No se permite el envío de mensajes masivos no solicitados.
              </li>
              <li>
                Se debe respetar la frecuencia máxima de mensajes permitida.
              </li>
              <li>
                Los mensajes deben ser relevantes y proporcionar valor al
                usuario.
              </li>
            </ul>
            <h4>13.2 Contenido Prohibido</h4>
            <ul>
              <li>Contenido que viole las políticas de Meta o WhatsApp.</li>
              <li>Mensajes que promuevan actividades ilegales.</li>
              <li>Contenido que infrinja derechos de propiedad intelectual.</li>
              <li>Mensajes que contengan información falsa o engañosa.</li>
              <li>Contenido que promueva el odio o la discriminación.</li>
              <li>Mensajes que contengan material explícito o inapropiado.</li>
            </ul>
            <h4>13.3 Privacidad y Datos</h4>
            <ul>
              <li>
                Cumplimiento del Reglamento General de Protección de Datos
                (RGPD) y otras leyes aplicables.
              </li>
              <li>
                Obtención de consentimiento explícito para el procesamiento de
                datos.
              </li>
              <li>Implementación de medidas de seguridad adecuadas.</li>
              <li>Respeto a los derechos de los usuarios sobre sus datos.</li>
              <li>
                Notificación de violaciones de datos según lo requiera la ley.
              </li>
            </ul>
            <h3>14. Cumplimiento con Meta</h3>
            <p>Nos comprometemos a:</p>
            <ul>
              <li>
                Mantener actualizada nuestra implementación según las políticas
                de Meta.
              </li>
              <li>Responder rápidamente a cualquier solicitud de Meta.</li>
              <li>Reportar cualquier violación de las políticas de Meta.</li>
              <li>Cooperar con Meta en investigaciones de cumplimiento.</li>
              <li>
                Mantener registros de cumplimiento según lo requiera Meta.
              </li>
            </ul>
            <div class="last-updated">
              <p>Última actualización: 25/05/2025 — Versión 2.0</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <footer class="main-footer">
      <!--Widgets Section-->
      <div class="widgets-section">
        <div class="auto-container">
          <div class="row">
            <!--Footer Column-->
            <div class="footer-column">
              <div class="footer-widget about-widget">
                <h3 class="widget-title" style="z-index: 10">SOFIA</h3>
                <router-link class="redirect center-logo" to="/">
                  <div class="logo-container">
                    <div class="logo" ref="logo">
                      <div class="logo-inner">
                        <img
                          style="width: 55px"
                          src="/landing/log-sof-icon.png"
                          alt="Sofia"
                        />
                      </div>
                    </div>
                    <!-- <ParticlesLayer :amount="150" /> -->
                  </div>
                </router-link>
                <ul class="social-icon-two">
                  <li>
                    <a
                      href="https://www.linkedin.com/company/smart-sales-agent/"
                      target="_blank"
                    >
                      <i class="fab fa-linkedin"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/sofia_agente?igsh=MTIzdjBmcjVxbmk3eQ=="
                      target="_blank"
                    >
                      <i class="fab fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://wa.me/584145038466" target="_blank">
                      <i class="fab fa-whatsapp"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <!--Footer Column-->
            <div class="footer-column">
              <div class="footer-widget">
                <h3 class="widget-title">Explorar</h3>
                <ul class="user-links">
                  <li>
                    <router-link :to="{ name: 'landing', hash: '#start' }"
                      >Inicio</router-link
                    >
                  </li>
                  <li>
                    <router-link :to="{ name: 'landing', hash: '#features' }"
                      >Características</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{ name: 'landing', hash: '#how-it-works' }"
                      >¿Cómo funciona?</router-link
                    >
                  </li>
                  <li>
                    <router-link :to="{ name: 'landing', hash: '#pricing' }"
                      >Precios</router-link
                    >
                  </li>
                  <li>
                    <router-link :to="{ name: 'landing', hash: '#about' }"
                      >Acerca de</router-link
                    >
                  </li>
                  <li>
                    <router-link :to="{ name: 'landing', hash: '#contact' }"
                      >Contacto</router-link
                    >
                  </li>
                </ul>
              </div>
            </div>
            <!--Footer Column-->
            <div class="footer-column">
              <div class="footer-widget contact-widget">
                <h3 class="widget-title">Contacto</h3>
                <div class="widget-content">
                  <ul class="contact-info">
                    <li>
                      <i class="fa fa-envelope"></i>
                      <a href="mailto:contacto@agentesofia.com"
                        >contacto@agentesofia.com</a
                      >
                    </li>
                    <li>
                      <i class="fa fa-phone-square"></i>
                      <a href="tel:+584145038466">+58 414-5038466</a>
                    </li>
                    <li>
                      <i class="fab fa-whatsapp"></i>
                      <a href="https://wa.me/584145038466">WhatsApp</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <!--Footer Column-->
            <div class="footer-column">
              <div class="footer-widget">
                <h3 class="widget-title">Documentos Legales</h3>
                <ul class="user-links">
                  <li>
                    <router-link to="/privacy"
                      >Política de Privacidad</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/terms"
                      >Términos y Condiciones</router-link
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--Footer Bottom-->
      <div class="footer-bottom">
        <div class="auto-container">
          <div class="inner-container">
            <div class="copyright-text">
              © Copyright 2025 por
              <router-link :to="{ name: 'landing', hash: '#start' }"
                >Agente Sofia</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import AnimatedAiBackground from "./AnimatedAiBackground.vue";

export default {
  name: "Terms",
  components: {
    AnimatedAiBackground,
  },
};
</script>

<style lang="css">
.content-landing {
  max-width: 1200px;
  min-height: 0 !important;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}
.title {
  font-size: 3rem;
  margin-bottom: 1rem;
}
.animate {
  animation: fadeInUp 1s ease forwards;
  animation-play-state: paused;
  opacity: 0;
}

.logo {
  position: absolute;
  animation: pulse 6s infinite ease-in-out;
  filter: drop-shadow(0 0 10px #00c8ff);
  transform-style: preserve-3d;
  transition: transform 1.5s ease;
  /* transform: translate(-50%, -50%); */
}

.logo-con {
  filter: drop-shadow(0 0 10px #00c8ff);
  transform-style: preserve-3d;
  transition: transform 1.5s ease;
}
/* Animaciones */

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Logo */
/* @keyframes pulse {
  0% {
    transform: scale(1) rotate(0deg);
    box-shadow: 0 0 50px rgba(0, 198, 255, 0.7);
  }
  50% {
    transform: scale(1.05) rotate(5deg);
    box-shadow: 0 0 70px rgba(0, 114, 255, 0.9);
  }
  100% {
    transform: scale(1) rotate(0deg);
    box-shadow: 0 0 50px rgba(0, 198, 255, 0.7);
  }
} */
@keyframes pulse {
  0%,
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.05);
    opacity: 0.8;
  }
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

@keyframes typing {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}

@keyframes blink {
  50% {
    border-color: transparent;
  }
}
</style>

<style lang="scss" scoped>
.body-landing {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif !important;
  // background: linear-gradient(135deg, #052e6d, #0a4a9f);
  color: #ffffff;
  overflow-x: hidden;
}

.legal-content {
  opacity: 1 !important; /* Asegurar que el contenido es visible */
  transform: none !important;
  flex: 1;
  padding: 80px 0;
  z-index: 9999;
}

/* Mejorar contraste y legibilidad */
.document-container {
  background: rgba(0, 20, 40, 51%) !important; /* Fondo más oscuro */
  color: #e0f0ff !important; /* Color de texto más claro */

  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 50px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  margin-bottom: 50px;
}

.document-content h2 {
  color: #4fc3f7 !important; /* Color más vibrante para títulos */
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
}

/* Header */
.legal-header {
  background: rgba(0, 0, 0, 0.2);
  padding: 20px 0;
  position: sticky;
  top: 0;
  z-index: 1000;
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;

  text-align: center;
  margin-bottom: 50px;
  padding-bottom: 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif !important;
  color: #ffffff;
}

h1 {
  font-size: 5rem;
  margin-bottom: 20px;
  line-height: 1.1;
  font-weight: 800;
  text-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

h2 {
  font-size: 2.5rem;
  margin-bottom: 30px;
  font-weight: 700;
  position: relative;
}

h2:after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 60px;
  height: 4px;
  background: #28a9e0;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

h3 {
  font-weight: bold;
}

.widget-title {
  font-size: 1.5rem;
  margin-bottom: 25px;
  position: relative;
  padding-bottom: 15px;
}

.widget-title::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 30px;
  height: 2px;
  background: #28a9e0;
}

p {
  font-size: 1.5rem;
  line-height: 1.8;
  max-width: 700px;
  margin-bottom: 30px !important;
}

.document-header {
  text-align: center;
  margin-bottom: 50px;
  padding-bottom: 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.document-header h1 {
  font-size: 2.8rem;
  margin-bottom: 20px;
  color: #28a9e0;
}

.document-header p {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.8);
  max-width: 800px;
  margin: 0 auto;
}

.document-content {
  line-height: 1.8;
}

.document-content h2 {
  font-size: 1.8rem;
  margin: 40px 0 20px;
  color: #28a9e0;
  position: relative;
  padding-left: 20px;
}

.document-content h2::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 60%;
  width: 5px;
  background: #28a9e0;
  border-radius: 5px;
}

.document-content h3 {
  font-size: 1.4rem;
  margin: 30px 0 15px;
  color: #1a7bbd;
}

.document-content p {
  margin-bottom: 20px;
  font-size: 1.05rem;
}

.document-content ul {
  padding-left: 30px;
  margin-bottom: 30px;
}

.document-content li {
  margin-bottom: 12px;
  position: relative;
}

.document-content li::before {
  content: "•";
  color: #28a9e0;
  font-size: 1.5rem;
  position: absolute;
  left: -20px;
  top: -3px;
}

.last-updated {
  text-align: right;
  font-style: italic;
  margin-top: 40px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.95rem;
}

/* Footer */
.main-footer {
  position: relative;
  background: linear-gradient(
    145deg,
    rgba(2, 13, 34, 0.98),
    rgba(5, 46, 109, 0.96)
  );
  color: #ffffff;
  padding: 80px 0 0;
  overflow: hidden;
  margin-top: auto;
  border-top: 1px solid rgba(79, 195, 247, 0.22);
  box-shadow: 0 -24px 60px rgba(0, 0, 0, 0.22);
}

.main-footer .bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  opacity: 0.1;
}

.widgets-section {
  position: relative;
  z-index: 2;
}

.auto-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
}

.footer-column {
  padding: 0 15px;
  margin-bottom: 40px;
  flex: 1 1 220px;
  min-width: 220px;
}

.footer-widget {
  margin-bottom: 40px;
}

/* .about-widget .logo {
    margin-bottom: 20px;
}

.about-widget .logo img {
    max-width: 200px;
} */

.about-widget .text {
  margin-bottom: 25px;
  line-height: 1.7;
  font-size: 1rem;
  max-width: 350px;
}

.social-icon-two {
  display: flex;
  gap: 15px;
  list-style: none;
  padding: 0;
  justify-content: center;
}

.social-icon-two a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  color: white;
  font-size: 18px;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.social-icon-two a:hover {
  background: #28a9e0;
  transform: translateY(-3px);
}

.user-links {
  list-style: none;
  padding: 0;
}

.user-links li {
  margin-bottom: 12px;
}

.user-links li a {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  font-size: 1.05rem;
}

.user-links li a:hover {
  color: #28a9e0;
  padding-left: 5px;
}

.contact-info {
  list-style: none;
  padding: 0;
}

.contact-info li {
  margin-bottom: 15px;
  display: flex;
  align-items: flex-start;
}

.contact-info li i {
  font-size: 1.2rem;
  margin-right: 15px;
  color: #28a9e0;
  min-width: 20px;
}

.contact-info li a {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.contact-info li a:hover {
  color: #28a9e0;
}

.footer-bottom {
  position: relative;
  background: rgba(0, 7, 24, 0.5);
  z-index: 999;
  padding: 25px 0;
  text-align: center;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.legal-back-link {
  width: fit-content;
  margin-bottom: 24px;
  padding: 10px 14px;
  display: inline-flex;
  align-items: center;
  gap: 9px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.08);
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 600;
  transition: all 0.25s ease;
}

.legal-back-link:hover {
  color: #ffffff;
  background: rgba(40, 169, 224, 0.25);
  transform: translateX(-3px);
}

.copyright-text {
  color: rgba(255, 255, 255, 0.7);
  font-size: 1rem;
}

.copyright-text a {
  color: #28a9e0;
  text-decoration: none;
}

/* Diseño del logo SofIA */
.logo-container {
  position: relative;
  margin: 0 auto 40px;
  width: 4rem;
  height: 4rem;
  perspective: 1000px;
}

.logo-inner {
  position: absolute;
  // width: 70%;
  // height: 70%;
  // background: rgba(255, 255, 255, 0.1);
  // border: 2px solid rgba(255, 255, 255, 0.2);
  // border-radius: 50%;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  backdrop-filter: blur(5px);
}
</style>
